import React from 'react';

export default function RegistrationOtp({ otp, id = 'registration-email-code' }) {
    return (
        <div className="form-group" aria-live="polite">
            {otp.sent && <>
                <label htmlFor={id}>Email verification code</label>
                <input id={id} className="form-control" type="text" inputMode="numeric"
                    autoComplete="one-time-code" maxLength={6} pattern="[0-9]{6}"
                    value={otp.code} onChange={e => otp.setCode(e.target.value.replace(/\D/g, ''))}
                    placeholder="Enter 6-digit code" disabled={otp.busy} />
                <small className="d-block mt-2">Your code expires in 10 minutes.</small>
                <button type="button" className="btn btn-link p-0 mt-2" onClick={otp.send}
                    disabled={otp.busy || otp.seconds > 0}>
                    {otp.seconds > 0 ? `Resend code in ${otp.seconds}s` : 'Resend code'}
                </button>
            </>}
            {!otp.sent && <small>We’ll email you a verification code before creating your account.</small>}
            {otp.message && <p className="text-success mt-2">{otp.message}</p>}
            {otp.error && <p className="text-danger mt-2" role="alert">{otp.error}</p>}
        </div>
    );
}
